import { t } from "i18next"
import { Color } from "../../../../core/const/const"
import { useState } from "react"
import { QualityCheckDetailDto } from "../../model/qualityCheckDtos"
import { Card, Col, Row } from "../../../../core/components"

interface QualityCheckDetailsTopProps {
    details: QualityCheckDetailDto
}

const getStatusText = (state: number): string => {
    switch(state) {
        case 0:
            return t("Scheduled")
        case 1:
            return t("Active")
        case 2:
            return t("Finished")
        case 3:
            return t("Expired")
        default:
            return t("Unknown State")
    }
}
const getStatusColor = (state: number): string => {
    switch(state) {
        case 0:
            return Color.scheduled
        case 1:
            return Color.active
        case 2:
            return Color.finished
        case 3:
            return Color.expired
        default:
            return Color.none
    }
}

export default function QualityCheckDetailsTop({details}: QualityCheckDetailsTopProps) {
    const [status] = useState<string>(getStatusText(details.state));

    return (
        <Row>
            <Col>
                <Card className="section background-glass border-light" margin={"0"} borderRadius="small">
                    <Col>
                        <Row>
                            <span className="text quality-check-detail-title">
                                {details.checklist.name}
                            </span>
                            <Row.End>
                                <div className="pill" style={{ backgroundColor: getStatusColor(details.state) }}>
                                    {status}
                                </div>
                            </Row.End>
                        </Row>

                        <p>
                            {details.checklist.description}
                        </p>
                        <div className="mt-025">
                            <span className="key">{t("Inspector Name")}: </span>{details.inspectorName || t("Not Assigned")}
                        </div>
                    </Col>
                </Card>
            </Col>
            <Col>
                <Card className="section background-glass" margin={"0"} borderRadius="small">
                    <h2>{t("Details")}</h2>
                    <div className="mt-025">
                        <span className="key">{t("Scheduled On")}: </span>
                        {new Date(details.scheduledOn).toLocaleDateString()}
                    </div>
                    <div className="mt-025">
                        <span className="key">{t("Check Started")}: </span>
                        {details.checkStarted
                            ? new Date(details.checkStarted).toLocaleString()
                            : t("Not Started")}
                    </div>
                    <div className="mt-025">
                        <span className="key">{t("Check Ended")}: </span>
                        {details.checkEnded
                            ? new Date(details.checkEnded).toLocaleString()
                            : t("Not Ended")}
                    </div>
                </Card>
            </Col>
        </Row>
    )
}
